import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import Parser from "html-react-parser";
import Button from "../shared/button/Button";
import labels from "./labels";
import Saving from "../shared/loaders/Saving";
import {
  DisengageWrapper,
  Modal,
  Title,
  CloseButton,
  Inner,
  Form,
  Label,
  TextInput,
  ButtonsWrapper,
  Field,
  Error,
} from "./styles/disengage-form-styles";

const RemovePslForm = (props) => {
  const {
    handleRemoveFromPslSubmit,
    setRemoveFromPslMessage,
    closeRemoveFromPslModal,
    recruiterCompanyName,
    formLoading,
    errors,
  } = props;

  return (
    <DisengageWrapper>
      <Modal>
        <Title>
          Remove agency from PSL
          <CloseButton onClick={(e) => closeRemoveFromPslModal(e)}>
            <FontAwesomeIcon icon={faTimes} />
          </CloseButton>
        </Title>
        <Inner>
          {formLoading && <Saving white />}
          <Form onSubmit={handleRemoveFromPslSubmit}>
            <Label>
              You are about to remove<strong> {recruiterCompanyName} </strong>
              from your PSL.
              <br /> <br />
              {Parser(labels.removeFromPsl)}
            </Label>
            <Field>
              <TextInput
                placeholder="Enter your message..."
                onChange={setRemoveFromPslMessage}
              />
              {errors.message && <Error>{`Message ${errors.message}.`}</Error>}
            </Field>
            <ButtonsWrapper>
              <Button
                secondary
                buttonName="Cancel"
                onClickAction={(e) => closeRemoveFromPslModal(e)}
              />
              <Button primary buttonName="Remove" type="submit" />
            </ButtonsWrapper>
          </Form>
        </Inner>
      </Modal>
    </DisengageWrapper>
  );
};

RemovePslForm.propTypes = {
  handleRemoveFromPslSubmit: PropTypes.func.isRequired,
  setRemoveFromPslMessage: PropTypes.func.isRequired,
  closeRemoveFromPslModal: PropTypes.func.isRequired,
  formLoading: PropTypes.bool.isRequired,
  errors: PropTypes.shape({
    message: PropTypes.string,
  }).isRequired,
  recruiterCompanyName: PropTypes.string.isRequired,
};

export default RemovePslForm;
